import React from 'react';
import { Box, Container, Typography, Link, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 3, 
        bgcolor: 'primary.dark',
        color: 'white',
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Box 
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: isMobile ? 'center' : 'flex-start',
          }}
        >
          <Box sx={{ mb: isMobile ? 2 : 0 }}>
            <Typography variant="h6" gutterBottom>
            Convertisseur Factur-X
            </Typography>
            <Typography variant="body2">
              Solution pour convertir vos factures PDF en format Factur-X
            </Typography>
          </Box>
          
          <Box sx={{ textAlign: isMobile ? 'center' : 'right' }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              © {new Date().getFullYear()} Convertisseur Factur-X
            </Typography>
            <Box>
              <Link href="https://www.eukles.com/mentions-legales" target="_blank" color="inherit" sx={{ mx: 1 }}>
                Mentions légales
              </Link>
              <Link href="https://www.eukles.com/politique-de-confidentialite" target="_blank" color="inherit" sx={{ mx: 1 }}>
                Confidentialité
              </Link>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
